import { render, staticRenderFns } from "./ScriptGroupEditor.vue?vue&type=template&id=ff79bbfc&"
import script from "./ScriptGroupEditor.vue?vue&type=script&lang=ts&"
export * from "./ScriptGroupEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports